import { render } from "./UserSelector.vue?vue&type=template&id=55f108fe&ts=true"
import script from "./UserSelector.vue?vue&type=script&lang=ts"
export * from "./UserSelector.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=55f108fe&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__